import { PromoCreatePage } from '@/features/promo/pages/PromoCreatePage'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/promo/create')({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["promo.create"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: PromoCreatePage,
})
